import "./App.css";
import Herosection from "./components/herosection/Herosection";
import Counter from "./components/counter/Counter";
import Tools from "./components/tools/Tools";
import Property from "./components/property/Property";
import ShareCard from "./components/sharecard/ShareCard";
import Exposure from "./components/exposure/Exposure";
import Trust from "./components/trust/Trust";
import Trustnew from "./components/trustnew/Trustnew";
import Setup from "./components/setup/Setup";
import Footer from "./components/footer/Footer";
import Thankyou from "./components/Thankyou/Thankyou";
import { Route, Router, Routes } from "react-router-dom";

function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <Herosection />
            <Counter />
            <Tools />
            <Property />
            <Exposure />
            <ShareCard />
            <Trustnew/>
            <Setup />
            <Footer />
          </>
        }
      />
      
      <Route path="/thankyou" element={<Thankyou title="Thankyou" />} />
    </Routes>
  );
  // return (
  //   <div className="App">
  //     <Herosection />
  //     <Counter />
  //     <Tools />
  //     <Property />
  //     <Exposure />
  //     <ShareCard />
  //     <Trust />
  //     <Setup />
    
  //       <Routes>
  //         <Route path="/thankyou" element={<Thankyou title="Thankyou" />} />
  //       </Routes>
     
  //     <Footer />
  //   </div>
  // );
}

export default App;
